import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';

import QuizTitleComponent from "../QuizTitleComponent";
import QuizResultItem from "./QuizResultItem";

const QuizResult = (props) => {

    const { userAnswerData } = props;
    const userSelectedIndex = userAnswerData.userSelectedIndex;
    const { questionText, options } = props.questionData;

    const answerCorrectIndex = options.findIndex(i => i.isRight === true);

    const userSelectedAnswerText = options[userSelectedIndex].text;
    const correctAnswerText = options[answerCorrectIndex].text;

    const isCorrect = userSelectedIndex === answerCorrectIndex

    return (
        <View style={{ alignItems: 'center', flex: 1, minWidth: '100%' }}>

            <QuizTitleComponent title={questionText} />

            <QuizResultItem
                correctAnswer={correctAnswerText}
                userAnswer={userSelectedAnswerText}
                isCorrect={isCorrect}
            />

        </View>
    )
}

QuizResult.propTypes = {
    questionData: PropTypes.any.isRequired,
    userAnswerData: PropTypes.any.isRequired,
}

export default QuizResult;
